import { useSelector } from 'react-redux';

import {
  avatarList,
  hairColorPalette,
  shirtColorPalette,
  skinColorPalette,
} from 'enrollment/app/constants';
import { AddYourDocumentsCardProfileData } from './AddYourDocumentsCardProfileData';
import { selectSubscriberDetails } from 'enrollment/features/Profile/services';
import { selectSubscriberDocuments } from 'enrollment/features/ToDoList/services';
import { DependentDto } from 'enrollment/features/MyFamily/types';
import {
  DocumentRequest,
  DocumentTypeDto,
} from 'enrollment/features/ToDoList/types';
import {
  mapDependentDocRequestDetails,
  mapSubscriberRequestdetails,
} from '../utils';
import { useDocumentRequestQuery, useEnrollmentFamilyQuery } from 'enrollment/queries';
import {
  useConfigurationQuery,
  useEnrollmentContextQuery,
} from 'theSource/queries';

export interface DocRequestDetails {
  key: string;
  documentRequests: DocumentRequest[];
  profileDetails: DependentDto | undefined;
  documentTypes: DocumentTypeDto[];
}

export const AddYourDocumentsCard = () => {
  const subscriberDetails = useSelector(selectSubscriberDetails);
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;
  const enrollmentContext = useEnrollmentContextQuery({
    enabled: true,
    apiHost: String(lumosApiHost),
  });
  const hasPendingLE = enrollmentContext.enrollmentContext?.data.find(
    (enrollmentContext) =>
      enrollmentContext.enrollment_type_lookup_code === 'life_event' &&
      enrollmentContext.status === 'complete'
  );

  const { dependentsData } = useEnrollmentFamilyQuery({
    lumosEnabled: true,
    manualEnrollmentContextOverride: hasPendingLE ? 'life_event' : undefined,
  });
  const dependentProfiles = dependentsData?.data?.dependents || [];

  const { documentRequestsData } = useDocumentRequestQuery({
    lumosEnabled: true,
  });

  const documentRequestApiData = documentRequestsData && documentRequestsData?.data;

  const dependentDocRequestDetails = mapDependentDocRequestDetails(
    documentRequestApiData,
    dependentProfiles
  );
  const subscriberRequestdetails = mapSubscriberRequestdetails(
    documentRequestApiData,
    subscriberDetails
  );

  const allDocumentDetails = [
    subscriberRequestdetails,
    ...dependentDocRequestDetails,
  ].flat(2);

  return (
    <div data-testid="add-your-documents-card">
      {allDocumentDetails.map((details, index) => {
        const profilePicture =
          details.profileDetails?.dependent_profile?.profile_picture;

        const avatarValues = details.profileDetails?.dependent_profile
          ?.avatar as string;
        const avatarPicture = avatarList.filter(
          (item) => avatarValues && avatarValues?.split('_')[0] === item.name
        );
        const avatarSkincolor = skinColorPalette?.filter(
          (item) => avatarValues && avatarValues?.split('_')[1] === item.name
        );
        const avatarHairColor = hairColorPalette?.filter(
          (item) => avatarValues && avatarValues?.split('_')[2] === item.name
        );
        const avatarShirtColor = shirtColorPalette?.filter(
          (item) => avatarValues && avatarValues?.split('_')[3] === item.name
        );

        return (
          <div key={index}>
            {details && details?.documentRequests?.length > 0 && (
              <AddYourDocumentsCardProfileData
                profilePicture={profilePicture}
                saveAvatarName={avatarPicture[0]?.name}
                saveAvatarSkinTone={avatarSkincolor[0]?.colorCode}
                saveAvatarHairColor={avatarHairColor[0]?.colorCode}
                saveAvatarShirtColor={avatarShirtColor[0]?.colorCode}
                cardDetails={details}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
